import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { WhatsIncluded } from './components/WhatsIncluded';
import { Bonuses } from './components/Bonuses';
import { ForYou } from './components/ForYou';
import { Results } from './components/Results';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { ErrorBoundary } from './components/ErrorBoundary';
const META_PIXEL_ID = '26257470350562748';
// Global declaration for Meta Pixel
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    try {
      // If pixel already initialized, just refire PageView (e.g. on remount in SPAs).
      if (window.fbq) {
        window.fbq('track', 'PageView');
        return;
      }
      // Canonical Meta Pixel base code — adapted to work even when no
      // <script> tag exists yet in the document (some sandboxed previews).
      ;
      (function (f: any, b: Document, e: string, v: string) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          // eslint-disable-next-line prefer-rest-params
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e) as HTMLScriptElement;
        t.async = true;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else if (b.head) {
          b.head.appendChild(t);
        } else {
          b.body.appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', META_PIXEL_ID);
      window.fbq('track', 'PageView');
      // Inject the <noscript> fallback img recommended by Meta.
      if (!document.getElementById('fb-pixel-noscript')) {
        const noscript = document.createElement('noscript');
        noscript.id = 'fb-pixel-noscript';
        const img = document.createElement('img');
        img.height = 1;
        img.width = 1;
        img.style.display = 'none';
        img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
        noscript.appendChild(img);
        document.head.appendChild(noscript);
      }
    } catch (e) {
      // Never let pixel init break the page.
      // eslint-disable-next-line no-console
      console.warn('Meta Pixel init failed:', e);
    }
  }, []);
  return <ErrorBoundary data-id="element-0">
      <div className="min-h-screen bg-slate-50 font-sans selection:bg-emerald-200 selection:text-emerald-900" data-id="element-1">
        <Hero data-id="element-2" />
        <Benefits data-id="element-3" />
        <WhatsIncluded data-id="element-4" />
        <Bonuses data-id="element-5" />
        <ForYou data-id="element-6" />
        <Results data-id="element-7" />
        <Pricing data-id="element-8" />
        <Testimonials data-id="element-9" />
        <Footer data-id="element-10" />
        <SocialProofPopup data-id="element-11" />
      </div>
    </ErrorBoundary>;
}